<template>
  <component :is="tag" :id="id" class="header-navbar d-lg-flex p-0 bg-white border-top">
    <div class="container">
      <div class="row">
        <div class="col">
          <ul class="nav nav-tabs border-0 flex-column flex-lg-row">
            <li
              v-for="(item, idx) in items"
              :key="idx"
              :class="['nav-item', item.items && item.items.length ? 'dropdown' : '']"
            >
              <b-link
                :to="item.to"
                class="nav-link text-nowrap"
                v-on:click="ToggleDropdown('shn-' + idx)"
              >
                <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore" />
                {{ item.title }}
              </b-link>
              <b-collapse
                :id="`shn-${idx}`"
                v-if="item.items && item.items.length"
                class="dropdown-menu dropdown-menu-small"
                accordion="header-navbar-accordion"
              >
                <template v-for="(itemsSub, idxSub) in item.items">
                  <b-dropdown-item
                    :key="idxSub"
                    v-on:click="ToggleDropdown('shn-' + idx)"
                    :to="itemsSub.to"
                    :href="itemsSub.to"
                  >
                  <div
                    class="item-icon-sub mr-1 text-center"
                    style="width: 17px"
                    v-html="itemsSub.htmlBefore"
                    v-if="itemsSub.htmlBefore != null && itemsSub.htmlBefore != undefined && itemsSub.htmlBefore != ''"
                  ></div>
                    {{ itemsSub.title }}
                  </b-dropdown-item>
                  <b-dropdown-divider :key="'divider'+idxSub" v-if="itemsSub.dividerEnabled" />
                </template>
              </b-collapse>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </component>
</template>

<script>
export default {
  name: "header-navbar",
  props: {
    items: {
      type: Array,
      required: true
    },
    tag: {
      type: String,
      default: "div"
    },
    id: {
      type: String
    }
  },
  methods: {
    ToggleDropdown(id) {
      this.$root.$emit("bv::toggle::collapse", id);
    }
  }
};
</script>

<style lang="scss">
.header-navbar {
  .item-icon-wrapper {
    display: inline-block;
  }
  .item-icon-sub {
    display: inline-block;
  }
  .dropdown-menu {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/HeaderNavbar/HeaderNavbar.vue